import { useContext, useMemo } from 'react';

import { UpcomingTours } from '@zg-rentals/touring';
import { Box } from '@zillow/constellation-10';

import ConnectedModuleCard from '../../components/ConnectedModuleCard';
import { RMWContext } from '../../providers/RMWContext';
import { useSelector } from '../../selectors/useSelector';
import { AppSelectors } from '../../selectors';
import TouringPropertyDashboardCSEvents from '../../model/ClickstreamEvent/Touring/TouringPropertyDashboardCSEvents';
import { getFullCalendarPageUrl } from '../../utils/touringUtils';

import { useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing } from '@zg-rentals/ts-z-calendar-client-react-query';
import { LoadingHeading } from '@zg-rentals/loading-components';

const UpcomingToursModule = () => {
  const { paths } = useContext(RMWContext);
  const currentProperty = useSelector((state) => state.properties.currentProperty);
  const user = useSelector((state) => state.user);
  const { listingAlias, active } = currentProperty;
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  const inquiriesPath = `${paths.base}/lead-management/${listingAlias}`;
  const tourCalendarPath = useMemo(() => getFullCalendarPageUrl(listingAlias, paths), [listingAlias, paths]);

  const { data: touringTreatment, isLoading: isGetTouringTreatmentLoading } =
    useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing(
      {
        listingAlias,
      },
      { enabled: Boolean(listingAlias) },
    );

  const onCalendarClick = () => {
    TouringPropertyDashboardCSEvents.UpcomingToursMoreToursCta({ currentProperty, user });
  };

  return (
    <>
      {isGetTouringTreatmentLoading ? (
        <Box css={{ marginBottom: '400' }}>
          <ConnectedModuleCard isLoading={isGetTouringTreatmentLoading}>
            <LoadingHeading level={2} isLoading={isGetTouringTreatmentLoading} loadingWidth="100%">
              Upcoming Tours
            </LoadingHeading>
          </ConnectedModuleCard>
        </Box>
      ) : (
        touringTreatment &&
        touringTreatment.isTouringEnabledForListing &&
        (active || touringTreatment.hasBookedTours) && (
          <Box css={{ marginBottom: '400' }}>
            <ConnectedModuleCard>
              <UpcomingTours
                inquiriesPath={inquiriesPath}
                isScreenMobile={isScreenMobile}
                listingAlias={listingAlias}
                onCalendarClick={onCalendarClick}
                tourCalendarPath={tourCalendarPath}
                eventId={TouringPropertyDashboardCSEvents.UpcomingToursMoreToursCta.data_event_id}
              />
            </ConnectedModuleCard>
          </Box>
        )
      )}
    </>
  );
};

export default UpcomingToursModule;
